export default __webpack_public_path__ + "media/images/front/policy/background-1aa6c050042d88abd39f57fd689114f5.jpg";